import { useEffect, useState } from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getMensagemEnviadaDetalhe } from '../../services/MensagensEnviadasService/getMensagensEnviadas'

export function useMensagensEnviadasDetalhe() {
  const { id } = useParams()
  const [detalhe, setDetalhe] = useState<GetMensagemEnviadaDetalheType | null>(
    null
  )
  const [isLoading, setIsLoading] = useState(false)
  const [erro, setErro] = useState(false)

  const fetchDetalhe = async () => {
    setIsLoading(true)
    setErro(false)
    const result = await getMensagemEnviadaDetalhe(id)
    if ('message' in result) {
      toast.error(result.message)
      setErro(true)
    } else {
      setDetalhe(result)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    fetchDetalhe()
  }, [id])

  return { detalhe, isLoading, erro }
}
